'use client'

import { SignUpButton } from '@clerk/nextjs'

interface PublicSignUpButtonProps {
  className?: string
  children: React.ReactNode
}

export function PublicSignUpButton({
  className,
  children,
}: PublicSignUpButtonProps) {
  return (
    <SignUpButton mode="modal">
      <button type="button" className={className}>
        {children}
      </button>
    </SignUpButton>
  )
}
